import { render, staticRenderFns } from "./Tahapan.vue?vue&type=template&id=3c674a6c"
import script from "./Tahapan.vue?vue&type=script&lang=js"
export * from "./Tahapan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports